import Button from 'common-components/Button'
import PlusSvg from 'assets/svgr-icons/Plus.svg'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'

export const PopupActionsLeft = styled.div`
  display: flex;
  gap: 8px;
`

export const IconButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};
  cursor: pointer;

  & > svg {
    width: 16px;
    height: 16px;
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    background-color: ${COLORS.primaryLight};
  }
`

export const AddToTimelineButton = styled(Button)`
  padding: 20px 20px;

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    flex: 1;
  }
`

export const AddToTimelinePlusIcon = styled(PlusSvg)`
  width: 16px;
  height: 16px;
`
